import React from 'react'
import CacheBuster from 'react-cache-buster'
import 'react-chatbot-kit/build/main.css'
import ReactDOM from 'react-dom'
import App from './App'
import Loader from './components/global/Loader'
import reportWebVitals from './reportWebVitals'

const version = process.env.VERSION
const isProduction = process.env.NODE_ENV === 'production'

const pathname = window.location.pathname

if (pathname === '/') {
    window.location.assign('/fr/')
}

ReactDOM.render(
    <React.StrictMode>
        <CacheBuster
            currentVersion={version}
            isEnabled={isProduction} //If false, the library is disabled.
            isVerboseMode={false} //If true, the library writes verbose logs to console.
            loadingComponent={<Loader />} //If not pass, nothing appears at the time of new version check.
        >
            <App />
        </CacheBuster>
    </React.StrictMode>,
    document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
